import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue'

type PropsType = {
  padding?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteBox',
  props: {
    padding: { default: 16 }
  },
  setup(__props: any) {

const props = __props as { padding: number };



const style = computed<{ padding: string }>(() => ({
  padding: `${props.padding}px`,
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "white_box",
    style: _normalizeStyle(_unref(style))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})